import {useEffect, createRef} from 'react';
import {useSelector} from 'react-redux';
import WalletSelector from '../../../../selectors/pages/main/balance';
import {useNavigate, useLocation} from 'react-router-dom';
import BannerSvg from './banner';
import Content from './content';
import Timer from '../../halloween/timer';

export default () => {
    const {wallet} = useSelector(WalletSelector),
          navigate = useNavigate(),
          location = useLocation(),
          block = createRef();

    const resizeHandler = () => {
        let koef = document.body.offsetWidth / 430;
        const margin = ((koef - 1) / 2) * 163,
              marginLeft = (koef - 1) * 195;

        // block.current.style.height = `${163 * koef}px`;

        if(block.current) {
            if(koef > 1) {
                block.current.style.transform = `scale(${koef})`;
                block.current.style.marginTop = `${margin}px`;
                block.current.style.marginLeft = `${marginLeft}px`;
            } else {
                block.current.style.transform = `scale(${koef})`;
                block.current.style.marginTop = `${margin}px`;
                block.current.style.marginLeft = `${marginLeft}px`;
            }
        }
    }

    useEffect(() => {
        resizeHandler();
        window.addEventListener('resize', resizeHandler);
        return () => window.removeEventListener('resize', resizeHandler);
    }, [location]);

    if(wallet.project === "the_mask")
        return <></>;

    return (
        <div className="halloween-banner" onClick={e => navigate('/halloween')}>
            <div className="content" ref={block}>
                <div className="text">
                    <Timer timestamp={wallet.halloween.timestamp} timeoutKey={"main-page-halloween"} />
                </div>
                <Content />
            </div>
            <BannerSvg />
        </div>
    )
}